"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Location = function Location(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#035C5A' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: "".concat(className, " ").concat(animation)
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.078a.667.667 0 0 1-.523-.254C8.93 17.117 4.12 10.82 4.12 7.801A5.877 5.877 0 0 1 10 1.92a5.877 5.877 0 0 1 5.879 5.88c0 3.02-4.8 9.316-5.356 10.023a.667.667 0 0 1-.523.254Zm0-14.836a4.56 4.56 0 0 0-4.555 4.559c0 1.941 2.922 6.308 4.555 8.515 1.633-2.207 4.555-6.574 4.555-8.515A4.56 4.56 0 0 0 10 3.242Zm0 0",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.086 10.82a3.07 3.07 0 0 1-3.07-3.066 3.07 3.07 0 0 1 3.07-3.07 3.07 3.07 0 0 1 0 6.137Zm0-4.8a1.75 1.75 0 0 0-1.617 1.074 1.746 1.746 0 0 0 2.281 2.281 1.75 1.75 0 0 0 1.074-1.613A1.738 1.738 0 0 0 10.086 6Zm0 0",
    fill: color
  }));
};
var _default = exports["default"] = Location;